const { buildMcpAgentName } = require('./mcpToolNameSlug');

/**
 * Built-in MCP integrations: Kentik-defined servers that admins only switch on or off. Shared so the
 * backend, the settings tab and the chat agree on the key, the display name and the tool name.
 * The tool name comes from the key, not the display name: saved conversations and paused calls
 * refer to it, so a rebrand must not change it.
 */
const MCP_BUILTIN_SERVER_KEY = {
  INFOBLOX_IQ: 'infoblox_iq'
};

const MCP_BUILTIN_SERVERS = {
  [MCP_BUILTIN_SERVER_KEY.INFOBLOX_IQ]: {
    key: MCP_BUILTIN_SERVER_KEY.INFOBLOX_IQ,
    displayName: 'Infoblox',
    toolName: buildMcpAgentName(MCP_BUILTIN_SERVER_KEY.INFOBLOX_IQ)
  }
};

const MCP_BUILTIN_OAUTH_CALLBACK_PATH = '/api/ui/ai/builtin-mcp/oauth/callback';

function getMcpBuiltinServerByToolName(toolName) {
  return Object.values(MCP_BUILTIN_SERVERS).find((server) => server.toolName === toolName) || null;
}

module.exports = {
  MCP_BUILTIN_SERVER_KEY,
  MCP_BUILTIN_SERVERS,
  MCP_BUILTIN_OAUTH_CALLBACK_PATH,
  getMcpBuiltinServerByToolName
};
